import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { waLink, track } from "@/lib/api";

export function WhatsAppFloat() {
  return (
    <a href={waLink("Hello, I want to know more about Mashara Finance and its pricing.")}
      target="_blank" rel="noopener noreferrer" data-testid="whatsapp-float-button"
      onClick={() => track("whatsapp_click", { location: "float" })}
      className="hidden md:flex fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-[#25D366] text-white items-center justify-center shadow-lg hover:scale-105 transition-transform"
      aria-label="Chat on WhatsApp">
      <MessageCircle className="w-7 h-7" />
    </a>
  );
}

export function MobileStickyBar() {
  const navigate = useNavigate();
  return (
    <div data-testid="mobile-sticky-cta" className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-slate-200 p-3 flex gap-2 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]">
      <a href={waLink("Hello, I want to know more about Mashara Finance and its pricing.")}
        target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-button"
        onClick={() => track("whatsapp_click", { location: "sticky_bar" })}
        className="flex items-center justify-center gap-2 px-4 py-3 rounded-xl border border-emerald-700 text-emerald-700 font-semibold text-sm">
        <MessageCircle className="w-4 h-4" /> WhatsApp
      </a>
      <Button data-testid="sticky-trial-button"
        onClick={() => { track("hero_cta_click", { location: "sticky_bar" }); navigate("/signup"); }}
        className="flex-1 rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white py-3 text-sm font-semibold">
        Start Free Trial
      </Button>
    </div>
  );
}

export function ExitIntent() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("mf_exit_shown")) return;
    const handler = (e) => {
      if (e.clientY <= 0 && !sessionStorage.getItem("mf_exit_shown")) {
        sessionStorage.setItem("mf_exit_shown", "1");
        setShow(true);
        track("exit_intent_shown");
      }
    };
    document.addEventListener("mouseleave", handler);
    return () => document.removeEventListener("mouseleave", handler);
  }, []);

  return (
    <Dialog open={show} onOpenChange={setShow}>
      <DialogContent data-testid="exit-intent-modal" className="sm:max-w-md rounded-2xl">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-slate-900">Before you go</DialogTitle>
          <DialogDescription className="text-slate-600 text-base">
            See how Mashara Finance can replace your Excel files, manual payroll and scattered tools — with one connected platform.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-2">
          <Button data-testid="exit-trial-button"
            onClick={() => { track("hero_cta_click", { location: "exit_intent" }); navigate("/signup"); }}
            className="rounded-xl bg-emerald-700 hover:bg-emerald-800 text-white py-6">
            Start Free Trial
          </Button>
          <Button data-testid="exit-demo-button" variant="outline"
            onClick={() => navigate("/demo")}
            className="rounded-xl border-slate-300 py-6">
            Book a Demo
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
